import { Pipe, PipeTransform } from '@angular/core';
import { Insurant } from '@models/insurant';

/*
 * Show full name of Insurant
 */
@Pipe({
    standalone: true,
    name: 'fullName',
})
export class InsurantFullNamePipe implements PipeTransform {
    public transform(insurant: Insurant): string {
        return `${insurant.firstName ?? ''} ${insurant.lastName ?? ''}`.trim();
    }
}
